import { isVenueMapUrl } from '../../lib/venue-map-url';
import { cn } from '../../lib/utils';

/** Venue name. When a map link is stored, the name itself opens that link. */
export function VenueName({
  name,
  url,
  className,
}: {
  name: string;
  url?: string | null;
  className?: string;
}) {
  const href = url?.trim() ?? '';
  if (!isVenueMapUrl(href)) {
    return <span className={className}>{name}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'underline underline-offset-2 hover:text-[var(--color-text-primary)]',
        className,
      )}
    >
      {name}
    </a>
  );
}
